module.exports = __webpack_public_path__ + "static/media/59pic.f7fbaa68.jpg";